// frontend/src/hooks/useSettings.js
import { useState, useEffect } from 'react';
import axiosInstance from '../utils/axios';
import { currencies } from '../components/constants/currencies';

export const useSettings = () => {
    const [settings, setSettings] = useState({
        currency: { 
            code: 'USD', 
            symbol: currencies.find(c => c.code === 'USD')?.symbol || '$', 
            position: 'left' 
        }
    });

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await axiosInstance.get('/settings');
                if (response.data?.currency?.code) {
                    const currencyData = currencies.find(c => c.code === response.data.currency.code);
                    setSettings({
                        ...response.data,
                        currency: {
                            ...response.data.currency,
                            symbol: currencyData?.symbol || '$'
                        }
                    });
                }
            } catch (error) {
                console.error('Error fetching settings:', error);
            }
        };
        fetchSettings();
    }, []);

    const formatPrice = (price) => {
        const { symbol, position } = settings.currency;
        if (price === undefined || price === null) return '';
        return position === 'left' ? `${symbol}${price}` : `${price}${symbol}`;
    };

    return { settings, formatPrice };
};